var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrashbin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.55 5.64H15.84V3.08C15.84 2.67 15.5 2.33 15.09 2.33H8.9C8.49 2.33 8.15 2.67 8.15 3.08V5.64H4.44C4.03 5.64 3.69 5.98 3.69 6.39V9.48C3.69 9.89 4.03 10.23 4.44 10.23H5.06V21.91C5.06 22.32 5.4 22.66 5.81 22.66H18.17C18.58 22.66 18.92 22.32 18.92 21.91V10.23H19.54C19.95 10.23 20.29 9.89 20.29 9.48V6.39C20.29 5.98 19.95 5.64 19.54 5.64H19.55ZM17.43 21.17H6.57V10.31H17.43V21.17ZM9.65 3.83H14.34V5.64H9.65V3.83ZM5.2 7.14H18.8V8.73H5.2V7.14Z",
    fill: "#485060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89999 19.36C9.30999 19.36 9.64999 19.02 9.64999 18.61V12.68C9.64999 12.27 9.30999 11.93 8.89999 11.93C8.48999 11.93 8.14999 12.27 8.14999 12.68V18.61C8.14999 19.02 8.48999 19.36 8.89999 19.36Z",
    fill: "#485060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 19.36C15.51 19.36 15.85 19.02 15.85 18.61V12.68C15.85 12.27 15.51 11.93 15.1 11.93C14.69 11.93 14.35 12.27 14.35 12.68V18.61C14.35 19.02 14.69 19.36 15.1 19.36Z",
    fill: "#485060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.36C12.41 19.36 12.75 19.02 12.75 18.61V12.68C12.75 12.27 12.41 11.93 12 11.93C11.59 11.93 11.25 12.27 11.25 12.68V18.61C11.25 19.02 11.59 19.36 12 19.36Z",
    fill: "#485060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashbin);
export default __webpack_public_path__ + "static/media/icon-trashbin.5a84d9c5e8469d60fecdd299dbf24d05.svg";
export { ForwardRef as ReactComponent };